import React from "react";

import { ProductCategoryCard } from "../../../components/Cards";
import { Container } from "./styled";

const CategorySection = () => {
  const categoryData = [
    {
      id: 1,
      title: "LUXUTY",
      imgSrc: "/images/closets/category1.png",
    },
    {
      id: 2,
      title: "WAKL-IN",
      imgSrc: "/images/closets/category2.png",
    },
    {
      id: 3,
      title: "REACH-IN",
      imgSrc: "/images/closets/category3.png",
    },
    {
      id: 4,
      title: "KIDS",
      imgSrc: "/images/closets/category4.png",
    },
  ];

  return (
    <Container>
      {categoryData.map((category, index) => (
        <ProductCategoryCard
          key={index}
          title={category.title}
          imgSrc={category.imgSrc}
        />
      ))}
    </Container>
  );
};

export default CategorySection;
